import { useMutation } from "react-query";
import { editSingleFireAlarmSystem } from "actions/CarrierAgreementMgmt/Security";
import { toast } from "components/toastNotification";
import { useRecoilState } from "recoil";
import { FireAlarmSystemSaving } from "../atoms/atoms";

const useEditSingleFireAlarmSystem = () => {
    const [_, setIsSaving] = useRecoilState(FireAlarmSystemSaving);

    const { mutate, reset, isSuccess, data, error } = useMutation(editSingleFireAlarmSystem, {
        onError: () => {
            toast.fire(
                "Unexpected issue",
                "Unable to update the Fire Alarm System right now. Please try again shortly.",
                "error"
            );
            setIsSaving(false);
        }
    });

    return {
        mutate,
        isSuccess,
        data: error ? { status: 500 } : data ?? { status: 500 },
        reset
    }
};
export default useEditSingleFireAlarmSystem;
